import * as React from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'

const SimpleCheckbox = ({
  checked,
  setChecked,
  label,
  e2e,
}: {
  checked: boolean
  setChecked: (v: boolean) => void
  label: string
  e2e?: string
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked)
  }

  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          checked={checked}
          onChange={handleChange}
          data-e2e={e2e}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      }
    />
  )
}

export default SimpleCheckbox
